// filepath: c:\Users\lucaa\source\repos\lagitfolio\src\components\body\PersonalSkillsChart.tsx
import React from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  BubbleController,
} from 'chart.js';
import { Bubble } from 'react-chartjs-2';
import { useLanguage } from '../../contexts/languageContext';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(LinearScale, PointElement, Tooltip, Legend, BubbleController, ChartDataLabels);
const PersonalSkillsChart: React.FC = () => {
  const { t } = useLanguage();

  const data = {
    datasets: [
      {
        label: 'Problem Solving',
        data: [{ x: 50, y: 50, r: 42 }],
        backgroundColor: 'rgba(0, 121, 107, 0.7)',
        borderColor: 'rgba(0, 121, 107, 1)',
        borderWidth: 1,
      },
      {
        label: 'Team Working',
        data: [{ x: 65, y: 30, r: 27 }],
        backgroundColor: 'rgba(176, 190, 197, 0.7)',
        borderColor: 'rgba(176, 190, 197, 1)',
        borderWidth: 1,
      },
      {
        label: 'Value driven',
        data: [{ x: 35, y: 25, r: 32 }],
        backgroundColor: 'rgba(77, 208, 225, 0.7)',
        borderColor: 'rgba(77, 208, 225, 1)',
        borderWidth: 1,
      },
      {
        label: t('Proactivity'),
        data: [{ x: 20, y: 55, r: 30 }],
        backgroundColor: 'rgba(255, 204, 128, 0.7)',
        borderColor: 'rgba(255, 204, 128, 1)',
        borderWidth: 1,
      },
      {
        label: t('Curiosity'),
        data: [{ x: 35, y: 80, r: 37 }],
        backgroundColor: 'rgba(230, 238, 156, 0.7)',
        borderColor: 'rgba(230, 238, 156, 1)',
        borderWidth: 1,
      },
      {
        label: t('Engagement'),
        data: [{ x: 65, y: 85, r: 30 }],
        backgroundColor: 'rgba(255, 138, 128, 0.7)',
        borderColor: 'rgba(255, 138, 128, 1)',
        borderWidth: 1,
      },
      {
        label: t('Creativity'),
        data: [{ x: 80, y: 60, r: 32 }],
        backgroundColor: 'rgba(77, 182, 172, 0.7)',
        borderColor: 'rgba(77, 182, 172, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    layout: {
      padding: 0,
      autoPadding: false,
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: '#272727ff',
        font: {
          weight: 'bold' as const,
          size: 9,
        },
        formatter: (value: any, context: any) => {
          return context.dataset.label;
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context: any) => {
            const skill = context.dataset.label;
            const value = context.raw.r;
            return `${skill}: ${value}%`;
          },
        },
        label: (context: any) => {
          const skill = context.dataset.label;
          const value = context.raw.r;
          return `${skill}: ${value}%`;
        },
      },
    },
    scales: {
      x: {
        display: false,
        min: 0,
        max: 100,
      },
      y: {
        display: false,
        min: 0,
        max: 100,
      },
    },
  };

  return (
    <div style={{ position: 'relative', height: '250px' }}>
      <Bubble options={options} data={data} />
    </div>
  );
};

export default PersonalSkillsChart;
